import React from 'react';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { useRoomAssignmentListFiltersContext } from '../../../../hooks/use-get-room-assignment-list-filter';

const tenantRolesList = [
  {
    slug: 'coloc_buddy',
    displayValue: 'Coloc Buddy',
  },
  {
    slug: 'cleaning_manager',
    displayValue: 'Cleaning Manager',
  }
];

const TenantRolesFilter = () => {
  const { tenantRoles, setTenantRoles } = useRoomAssignmentListFiltersContext()!;

  return (
    <DropDown
      placeholder="All"
      className="w-[172px]"
      showLabel
      label="Tenant Roles"
      value={tenantRoles}
      {...(tenantRoles && {
        displayValue: tenantRoles.displayValue,
      })}
      onChange={setTenantRoles}
    >
      <DropDown.DropDownOptions>
        {tenantRolesList.map((option) => {
          return (
            <DropDown.DropDownOption key={option.displayValue} value={option}>
              <DropDown.DropDownOptionDefaultContent>
                {option.displayValue}
              </DropDown.DropDownOptionDefaultContent>
            </DropDown.DropDownOption>
          );
        })}
      </DropDown.DropDownOptions>
    </DropDown>
  );
};

export { TenantRolesFilter };
